import * as types from '../mutation-types'
import categoriesRepository from '../../api/categoriesRepository'

const state = {
  categoryToCreate: {},
  categoryToUpdate: {},
  searchedCategories: [],
  topCategories: [],
  categoriesByParent: [],
  isCategoryCreated: false,
  isCategoryUpdated: false,
  isCategoryDeleted: false,
  assignableCategories: [],
  breadcrumbs: [],
  categoryToSwitch: {},
  isCategorySwitched: false,
  categoryInfoToCreate: {},
  isCategoryInfoSaved: false,
  categoryInfo: {}
}

const getters = {
  categoryToCreate: state => state.categoryToCreate,
  categoryToUpdate: state => state.categoryToUpdate,
  searchedCategories: state => state.searchedCategories,
  topCategories: state => state.topCategories,
  categoriesByParent: state => state.categoriesByParent,
  isCategoryCreated: state => state.isCategoryCreated,
  isCategoryUpdated: state => state.isCategoryUpdated,
  isCategoryDeleted: state => state.isCategoryDeleted,
  assignableCategories: state => state.assignableCategories,
  breadcrumbs: state => state.breadcrumbs,
  categoryToSwitch: state => state.categoryToSwitch,
  isCategorySwitched: state => state.isCategorySwitched,
  categoryInfoToCreate: state => state.categoryInfoToCreate,
  isCategoryInfoSaved: state => state.isCategoryInfoSaved,
  categoryInfo: state => state.categoryInfo
}

const actions = {
  getCategoriesByParent ({commit}, parentId) {
    return categoriesRepository.getCategoriesByParent(parentId).then((response) => {
      commit(types.SET_CATEGORIES, response.data.message.categories)
      commit(types.SET_BREADCRUMBS, response.data.message.breadcrumbs)
    })
  },
  getAssignableCategories ({commit}) {
    return categoriesRepository.getAssignableCategories().then((response) => {
      commit(types.SET_ASSIGNABLE_CATEGORIES, response.data[0])
    })
  },
  searchAllCategories ({commit}, input) {
    return categoriesRepository.getCategoriesByInput(input).then((response) => {
      commit(types.SET_SEARCHED_CATEGORIES, response.data[0])
    })
  },
  getTopCategories ({commit}) {
    return categoriesRepository.getTopCategories().then((response) => {
      commit(types.SET_TOP_CATEGORIES, response.data)
    })
  },
  deleteCategory ({commit}, categoryId) {
    return categoriesRepository.deleteCategory(categoryId).then((response) => {
      if (response.data.success) {
        commit(types.SET_CATEGORY_DELETED, true)
      } else {
        commit(types.SET_CATEGORY_DELETED, false)
      }
    })
  },
  createCategory ({commit}) {
    return categoriesRepository.createCategory(state.categoryToCreate).then((response) => {
      if (response.data.success) {
        commit(types.SET_CATEGORY_CREATED, true)
        if (state.categoryToCreate.parentId) {
          commit(types.ADD_CATEGORY_TO_CATEGORIES, response.data.message)
        } else {
          commit(types.ADD_CATEGORY_TO_TOP_CATEGORIES, response.data.message)
        }
      } else {
        commit(types.SET_CATEGORY_CREATED, false)
      }
    })
  },
  updateCategory ({commit}) {
    return categoriesRepository.updateCategory(state.categoryToUpdate).then((response) => {
      if (response.data.success) {
        commit(types.SET_CATEGORY_UPDATED, true)
        if (state.categoryToUpdate.parentId == null) {
          commit(types.EDIT_CATEGORY_IN_TOP_LIST, response.data.message)
        } else {
          commit(types.EDIT_CATEGORY_IN_SUB_LIST, response.data.message)
        }
      } else {
        commit(types.SET_CATEGORY_UPDATED, false)
      }
    })
  },
  switchCategory ({commit}) {
    return categoriesRepository.switchCategory(state.categoryToSwitch).then((response) => {
      if (response.data.success) {
        commit(types.SET_CATEGORY_SWITCHED, true)
      } else {
        commit(types.SET_CATEGORY_SWITCHED, false)
      }
    })
  },
  saveCategoryInfo ({commit}) {
    return categoriesRepository.saveCategoryInfo(state.categoryInfoToCreate).then((response) => {
      if (response.data.success) {
        commit(types.SET_CATEGORY_INFO_SAVED, true)
      } else {
        commit(types.SET_CATEGORY_INFO_SAVED, false)
      }
    })
  },
  getCategoryInfo ({commit}, categoryId) {
    return categoriesRepository.getCategoryInfo(categoryId).then((response) => {
      commit(types.SET_CATEGORY_INFO, response.data)
    })
  }
}

const mutations = {
  [types.SET_CATEGORY_TO_CREATE] (state, payload) {
    state.categoryToCreate = payload
  },
  [types.SET_CATEGORY_TO_UPDATE] (state, payload) {
    state.categoryToUpdate = payload
  },
  [types.SET_CATEGORIES] (state, payload) {
    state.categoriesByParent = payload
  },
  [types.SET_SEARCHED_CATEGORIES] (state, payload) {
    state.searchedCategories = payload
  },
  [types.SET_TOP_CATEGORIES] (state, payload) {
    state.topCategories = payload
  },
  [types.SET_ASSIGNABLE_CATEGORIES] (state, payload) {
    state.assignableCategories = payload
  },
  [types.SET_CATEGORY_CREATED] (state, payload) {
    state.isCategoryCreated = payload
  },
  [types.SET_CATEGORY_UPDATED] (state, payload) {
    state.isCategoryUpdated = payload
  },
  [types.SET_CATEGORY_DELETED] (state, payload) {
    state.isCategoryDeleted = payload
  },
  [types.ADD_CATEGORY_TO_CATEGORIES] (state, payload) {
    state.categoriesByParent.push(payload)
  },
  [types.ADD_CATEGORY_TO_TOP_CATEGORIES] (state, payload) {
    state.topCategories.push(payload)
  },
  [types.EDIT_CATEGORY_IN_SUB_LIST] (state, payload) {
    state.categoriesByParent.forEach((category, index) => {
      if (category.id === payload.id) {
        state.categoriesByParent.splice(index, 1)
        state.categoriesByParent.push(payload)
      }
    })
  },
  [types.EDIT_CATEGORY_IN_TOP_LIST] (state, payload) {
    state.topCategories.forEach((category, index) => {
      if (category.id === payload.id) {
        state.topCategories.splice(index, 1)
        state.topCategories.push(payload)
      }
    })
  },
  [types.SET_BREADCRUMBS] (state, payload) {
    state.breadcrumbs = payload
  },
  [types.ADD_BREADCRUMB] (state, payload) {
    state.breadcrumbs.slice().unshift(payload)
  },
  [types.REMOVE_BREADCRUMB] (state, payload) {
    state.breadcrumbs.splice(payload)
  },
  [types.REMOVE_CATEGORY_FROM_CATEGORIES] (state, payload) {
    if (payload.parentId) {
      state.categoriesByParent.forEach((category, index) => {
        if (category.id === payload.id) {
          state.categoriesByParent.splice(index, 1)
        }
      })
    } else {
      state.topCategories.forEach((category, index) => {
        if (category.id === payload.id) {
          state.topCategories.splice(index, 1)
        }
      })
    }
  },
  [types.SET_CATEGORY_TO_SWITCH] (state, payload) {
    state.categoryToSwitch = payload
  },
  [types.SET_CATEGORY_SWITCHED] (state, payload) {
    state.isCategorySwitched = payload
  },
  [types.SET_CATEGORY_INFO_TO_CREATE] (state, payload) {
    state.categoryInfoToCreate = payload
  },
  [types.SET_CATEGORY_INFO_SAVED] (state, payload) {
    state.isCategoryInfoSaved = payload
  },
  [types.SET_CATEGORY_INFO] (state, payload) {
    state.categoryInfo = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
